




































































































































































































import Vue from "vue";
import Modal from "../../shared/modal/Modal.vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import {
  ContactDTO,
  DefaultPickupDataDef,
  DefaultPickupDataDTO,
  ShipmentDTO
} from "../../../model/data.model";
import { ContactService } from "../../../services/ContactService";
import ContactsSearch from "./ContactsSearch.vue";
import ImportGridModal from "../../shipments/ImportGridModal.vue";
import Accordion from "@/components/shared/Accordion.vue";
import PickupContent from "../../shipments/EditShipment/PickupContent.vue";
import { required } from "vuelidate/lib/validators";
import { PickupService } from "@/services/PickupService";
import { getYear } from "date-fns";

@Component({
  components: {
    MbeModal: Modal,
    ContactsSearch: ContactsSearch,
    MbeImportGridModal: ImportGridModal,
    MbeAccordion: Accordion,
    PickupContent: PickupContent
  }
})
export default class ContactsList extends Vue {
  showImportGrid = false;
  nameSelected = 1 as number;
  shipment: ShipmentDTO;
  model: DefaultPickupDataDef = {
    note: "",
    time: null,
    alternativeTime: null,
    cutOff: ""
  };
  timeOverlap = false as boolean;
  defPUAddress: DefaultPickupDataDTO = {
    tenantId: 0,
    multistoreId: 0,
    storeId: 0,
    customerId: "",
    preferredFrom: "",
    preferredTo: "",
    pickupCutoff: "",
    molUsername: "",
    alternativeFrom: "",
    alternativeTo: ""
  };
  @Prop({
    required: false,
    default: null
  })
  @Inject()
  contactService: ContactService;

  get addressesPickups() {
    if (this.$store.getters["customer/config"].pickupEnabled) {
      return [
        {
          name: "contacts",
          key: 1
        },
        {
          name: "pickups",
          key: 2
        }
      ];
    }
    return [];
  }

  exportContacts() {
    (this.$refs.contactsSearch as any).exportAll();
  }

  @Watch("model.time")
  @Watch("model.alternativeTime")
  checkOverlap() {
    if (
      this.model.time[1].getHours() >
        this.model.alternativeTime[0].getHours() ||
      this.model.time == null ||
      this.model.alternativeTime == null
    ) {
      this.timeOverlap = true;
    } else {
      this.timeOverlap = false;
    }
  }

  created() {
    if (this.$store.getters.customer.config.pickupDataId !== null) {
      PickupService.getDefaultPickupData(
        this.$store.getters.customer.config.customerId
      ).then(res => {
        this.model.cutOff = res.pickupCutoff;
        this.model.note = res.pickupNotes;
        this.model.time = [
          this.stringToDate(res.preferredFrom),
          this.stringToDate(res.preferredTo)
        ];
        this.model.alternativeTime = [
          this.stringToDate(res.alternativeFrom),
          this.stringToDate(res.alternativeTo)
        ];
      });
    }
    if (this.$route.params.typeAddress !== undefined) {
      this.nameSelected = Number(this.$route.params.typeAddress);
    } else {
      this.nameSelected = 1;
    }
  }

  updateSelected(item: any) {
    this.nameSelected = item.key;
  }

  isActive(item: any): boolean {
    return item.key === this.nameSelected;
  }

  clearForm() {
    this.model.alternativeTime = null;
    this.model.cutOff = "";
    this.model.note = "";
    this.model.time = null;
  }

  stringToDate(value: string) {
    const timeParts = value.split(":");
    const finalDate = new Date(
      2024,
      12,
      12,
      Number(timeParts[0]),
      Number(timeParts[1])
    );
    return finalDate;
  }

  saveDefPUAddress() {
    this.defPUAddress.alternativeFrom =
      this.model.alternativeTime[0] !== null
        ? this.getValueWithZero(this.model.alternativeTime[0].getHours()) +
          ":" +
          this.getValueWithZero(this.model.alternativeTime[0].getMinutes())
        : "";
    this.defPUAddress.alternativeTo =
      this.model.alternativeTime[1] !== null
        ? this.getValueWithZero(this.model.alternativeTime[1].getHours()) +
          ":" +
          this.getValueWithZero(this.model.alternativeTime[1].getMinutes())
        : "";
    this.defPUAddress.customerId = this.$store.getters.customer.config.customerId;
    this.defPUAddress.molUsername = this.$store.getters.customer.config.username;
    this.defPUAddress.multistoreId = this.$store.getters.customer.storeInfo.store.multiStoreId;
    this.defPUAddress.pickupCutoff = this.model.cutOff;
    this.defPUAddress.pickupNotes = this.model.note;
    (this.defPUAddress.preferredFrom =
      this.getValueWithZero(this.model.time[0].getHours()) +
      ":" +
      this.getValueWithZero(this.model.time[0].getMinutes())),
      (this.defPUAddress.preferredTo =
        this.getValueWithZero(this.model.time[1].getHours()) +
        ":" +
        this.getValueWithZero(this.model.time[1].getMinutes())),
      (this.defPUAddress.storeId = this.$store.getters.customer.storeInfo.store.id);
    this.defPUAddress.tenantId = this.$store.getters.customer.storeInfo.store.tenantId;
    if (!this.$store.getters.customer.config.pickupDataId) {
      PickupService.createDefaultPickupData(this.defPUAddress).then(res => {
        this.$store.state.customer.config.pickupData = res;
        this.$store.state.customer.config.pickupDataId = res.id;
      });
    } else if (this.$store.getters.customer.config.pickupDataId) {
      PickupService.updateDefaultPickupData(
        this.$store.getters.customer.config.customerId,
        this.defPUAddress
      ).then(res => {
        this.$store.state.customer.config.pickupData = res;
        this.$store.state.customer.config.pickupDataId = res.id;
      });
    }
  }

  getValueWithZero(value: number) {
    if (`${value.toString().length}` == "1") {
      return "0" + value.toString();
    } else {
      return value.toString();
    }
  }

  moveToDetail(contact: ContactDTO) {
    this.$router.push({
      name: "ContactDetails",
      params: {
        id: String(contact.id),
        typeAddress: String(this.nameSelected),
        molUsername: String(this.$store.getters.user.username)
      }
    });
  }
  importTabChenge(key: any) {
    this.nameSelected = key;
  }
}
